import invariant from 'tiny-invariant';

const _AppInsightsConnectionString = window.env.APP_INSIGHTS || '';
function getAppInsightsConnectionString(): string {
  const connectionString = _AppInsightsConnectionString;
  invariant(
    connectionString,
    'Missing App Insights Connection String, unable to configure telemetry'
  );
  return connectionString;
}

const TelemetryConfig = {
  AppInsightsConnectionString: getAppInsightsConnectionString(),
};

export default TelemetryConfig;
